import API from '../utils/api';
import { AGENT_SERVICE_ENDPOINT_URL } from '../constants/defaultValues';

const increaseDebt = async () => {
    return API.post(`${AGENT_SERVICE_ENDPOINT_URL}/balance/increase-debt`);
};

const addTicketBetSlip = async ticketCode => {
    const result = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/tickets/regenerate/${ticketCode}`);

    return result.data;
};

const createVoucher = async data => {
    const result = await API.post(`${AGENT_SERVICE_ENDPOINT_URL}/vouchers`, data);

    return result.data;
};

const getVouchers = async params => {
    const result = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/vouchers`, {
        params,
    });

    return result.data;
};

const getVoucher = async voucherCode => {
    const result = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/vouchers/${voucherCode}`);
    return result.data;
};

const printVoucher = async voucherCode => {
    const result = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/vouchers/print/${voucherCode}`);
    return result.data;
};

const reprintVoucher = async voucherCode => {
    const result = await API.post(`${AGENT_SERVICE_ENDPOINT_URL}/reprint/voucher`, {
        voucherCode,
    });

    return result.data;
};

const getTerminals = async () => {
    const result = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/terminal`);

    return result.data;
};

const getMaxStake = async data => {
    const result = await API.post(`${AGENT_SERVICE_ENDPOINT_URL}/tickets/max-stake`, data);

    return result.data;
};

const getTicketByRequestId = async ({ requestId }) => {
    const result = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/tickets/verify/${requestId}`);

    return result.data;
};

const downloadUnusedVouchers = async () => {
    const response = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/vouchers/download/unusedVouchers`, {
        responseType: 'blob',
    });

    return response.data;
};

const AgentService = {
    downloadUnusedVouchers,
    addTicketBetSlip,
    increaseDebt,
    createVoucher,
    getVouchers,
    printVoucher,
    reprintVoucher,
    getVoucher,
    getTerminals,
    getMaxStake,
    getTicketByRequestId,
};

export default AgentService;
